// Sondeo del tracker SIN DOM (testeable con fake timers). Regla de la casa: una
// pestaña suspendida NO corre setInterval, así que el rescate va en el FLANCO
// de visibilidad — al volver, se consulta de inmediato y se retoma el ritmo
// (memoria del repo sobre timers). Con la pestaña oculta no se sondea nada.
import type { TrackingSnapshot } from "./types"

export const POLL_INTERVAL_MS = 10_000

export type PollerDeps = {
  fetchSnapshot: () => Promise<TrackingSnapshot | null>
  onSnapshot: (s: TrackingSnapshot) => void
  intervalMs?: number
  isHidden?: () => boolean
  onVisible?: (cb: () => void) => () => void
}

export function createTrackingPoller(initial: TrackingSnapshot, deps: PollerDeps): { start(): void; stop(): void } {
  const interval = deps.intervalMs ?? POLL_INTERVAL_MS
  let active = initial.active
  let stopped = false
  let inFlight = false
  let timer: ReturnType<typeof setTimeout> | null = null
  let unsubscribe: (() => void) | null = null

  function schedule(): void {
    if (timer === null) timer = setTimeout(tick, interval)
  }

  async function tick(): Promise<void> {
    timer = null
    if (stopped || !active) return
    // Oculta: se duerme aquí. La despierta el flanco de visibilidad (onVisible).
    if (deps.isHidden?.()) return
    if (!inFlight) {
      inFlight = true
      try {
        const s = await deps.fetchSnapshot()
        if (s && !stopped) {
          active = s.active
          deps.onSnapshot(s)
        }
      } catch {
        // transitorio: el siguiente tick reintenta
      } finally {
        inFlight = false
      }
    }
    if (!stopped && active) schedule()
  }

  return {
    start() {
      if (!active) return
      schedule()
      unsubscribe =
        deps.onVisible?.(() => {
          if (stopped || !active) return
          if (timer !== null) {
            clearTimeout(timer)
            timer = null
          }
          void tick()
        }) ?? null
    },
    stop() {
      stopped = true
      if (timer !== null) clearTimeout(timer)
      timer = null
      unsubscribe?.()
      unsubscribe = null
    },
  }
}
